import { ResponsiveButtonPrimary } from 'components/PositionList/styled'
import { ChevronDown } from 'react-feather'
import styled from 'styled-components'

export const PortfolioManageButton: typeof ResponsiveButtonPrimary = styled(ResponsiveButtonPrimary)`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 12px;
  `}
`

export function getExpandableBorderClass(isExpanded: boolean): string {
  return isExpanded ? 'sm:border-b border-transparent' : 'sm:border-b border-kodiak-border-secondary'
}

interface PortfolioExpandIconProps {
  isExpanded: boolean
  className?: string
  size?: number
}

export function PortfolioExpandIcon({ isExpanded, className = '', size = 20 }: PortfolioExpandIconProps) {
  const classes = [
    'text-kodiak-text-secondary transition-transform duration-200',
    isExpanded ? 'rotate-180' : '',
    className,
  ]

    .filter(Boolean)
    .join(' ')

  return <ChevronDown size={size} className={classes} />
}
